module.exports = __webpack_public_path__ + "static/media/14.f2eb037b.jpg";